import {
  MortgageLeadTassoPurpose,
  MortgageLeadTassoRateType,
} from '@tassomutuo-backoffice/types';

/** Labels and values match the dedicated endpoint contract exactly. */
export const LEAD_TASSO_PURPOSE_OPTIONS: {
  value: MortgageLeadTassoPurpose;
  label: string;
}[] = [
  { value: 'acquisto_prima_casa', label: 'Acquisto prima casa' },
  { value: 'acquisto_seconda_casa', label: 'Acquisto seconda casa' },
  {
    value: 'acquisto_ristrutturazione',
    label: 'Acquisto + ristrutturazione',
  },
  { value: 'acquisto_liquidita', label: 'Acquisto + liquidità' },
  { value: 'surroga', label: 'Surroga' },
];

/** Sent as `Number(value)`; kept as strings here for the MUI select contract. */
export const LEAD_TASSO_DURATION_OPTIONS = [5, 10, 15, 20, 25, 30, 35, 40].map(
  (years) => ({ value: String(years), label: `${years} anni` })
);

export const LEAD_TASSO_RATE_TYPE_OPTIONS: {
  value: MortgageLeadTassoRateType;
  label: string;
}[] = [
  { value: 'fisso', label: 'Fisso' },
  { value: 'variabile', label: 'Variabile' },
];

export type LeadTassoUnder36Choice = 'si' | 'no';

export const LEAD_TASSO_UNDER36_OPTIONS: {
  value: LeadTassoUnder36Choice;
  label: string;
}[] = [
  { value: 'si', label: 'Sì' },
  { value: 'no', label: 'No' },
];
